import React from 'react';
import { IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const QcFooterActions = ({ onChangeStatus, expanded, onToggleExpand }) => {
  return (
    <>
      <IconButton aria-label="Acceptat" onClick={() => onChangeStatus('Acceptat')}>
        <Typography variant="button" sx={{ color: '#32CD32' }}>Acceptat</Typography>
      </IconButton>
      <IconButton aria-label="Respins" onClick={() => onChangeStatus('Respins')}>
        <Typography variant="button" sx={{ color: '#FFD700' }}>Respins</Typography>
      </IconButton>
      <IconButton aria-label="Fake" onClick={() => onChangeStatus('Fake')}>
        <Typography variant="button" sx={{ color: '#FF4500' }}>Fake</Typography>
      </IconButton>
      <IconButton
        onClick={onToggleExpand}
        aria-expanded={expanded}
        aria-label="show more"
        sx={{
          transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: (theme) => theme.transitions.create('transform', { duration: theme.transitions.duration.shortest })
        }}
      >
        <ExpandMoreIcon />
      </IconButton>
    </>
  );
};

export default QcFooterActions;

